import { useMyCustomers } from '../hooks/queries';
import { capacityForRoute, capacityLabel, chooseCapacity, clearReleasePreview, releasePreview, rememberHomeCapacity, selectedCapacity, type Capacity } from './capacity';
import { Select } from '../ui/primitives';

export type CustomerView = 'review' | 'customer' | 'overview';

export function ViewSwitcher({ customerId, current }: { customerId?: string; current: CustomerView }) {
  const { data: mine } = useMyCustomers();
  if (!customerId) return null;
  const rows = (mine ?? []).filter((row) => row.customer_id === customerId);
  const offered = new Set<Capacity>();
  for (const row of rows) {
    for (const role of row.capacities ?? [row.my_role]) {
      if (role in capacityLabel) offered.add(role as Capacity);
    }
  }
  if (offered.has('team')) offered.add('practice_preview');
  const order: Capacity[] = ['team', 'attorney', 'customer_admin', 'customer', 'customer_readonly', 'customer_records', 'practice_preview'];
  const capacities = order.filter((capacity) => offered.has(capacity));
  if (capacities.length < 2) return null;
  const chosen = selectedCapacity(customerId);
  const defaultCapacity: Capacity = current === 'overview' ? 'team' : current === 'review' ?
    (offered.has('team') ? 'team' : 'attorney') :
    (offered.has('team') ? 'team' : offered.has('customer_admin') ? 'customer_admin' :
      offered.has('customer') ? 'customer' : offered.has('customer_readonly') ? 'customer_readonly' : 'customer_records');
  const inForce = capacityForRoute(window.location.pathname, chosen);
  const active = releasePreview(customerId) ? 'practice_preview' : inForce && offered.has(inForce) ? inForce : defaultCapacity;
  const switchTo = (capacity: Capacity) => {
    clearReleasePreview(customerId);
    chooseCapacity(customerId, capacity);
    rememberHomeCapacity(capacity);
    const path = capacity === 'team' ? `/customers/${customerId}` :
      capacity === 'attorney' ? `/c/${customerId}` : `/portal/${customerId}`;
    window.location.assign(path + window.location.search);
  };
  return (
    <div className="vx-capacity-switcher">
      <label htmlFor="vx-capacity">View as</label>
      <Select id="vx-capacity" aria-label="View as" title={capacityLabel[active]} value={active}
        onChange={(event) => switchTo(event.target.value as Capacity)}>
        {capacities.map((capacity) => <option key={capacity} value={capacity}>{capacityLabel[capacity]}</option>)}
      </Select>
    </div>
  );
}
